export default __webpack_public_path__ + "static/media/spacefitCover.b5da7d4e.jpg";